import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { handleOAuthCallback } from '@/lib/auth/oauth';
import { useAuth } from '@/lib/auth';

export function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser } = useAuth();
  const [error, setError] = React.useState<string | null>(null);

  useEffect(() => {
    const handleCallback = async () => {
      try {
        console.log('Starting OAuth callback handling...');
        const profile = await handleOAuthCallback();
        
        if (!profile) {
          throw new Error('Failed to get user profile');
        }

        console.log('Setting user profile:', profile);
        setUser(profile);
        
        // Get the stored redirect path or default to home
        const redirectPath = window.sessionStorage.getItem('authRedirectPath') || '/';
        window.sessionStorage.removeItem('authRedirectPath'); // Clean up
        
        navigate(redirectPath, { replace: true });
      } catch (error) {
        console.error('Auth callback error:', error);
        setError(error instanceof Error ? error.message : 'Authentication failed');
        
        // On error, redirect to home after a delay
        setTimeout(() => {
          navigate('/', { replace: true });
        }, 3000);
      }
    };

    handleCallback();
  }, [navigate, setUser, location]);

  return (
    <div className="min-h-screen pt-20 flex items-center justify-center">
      <div className="text-center">
        {error ? (
          <>
            <p className="text-red-500 mb-4">{error}</p>
            <p className="text-sand-400">Redirecting you back home...</p>
          </>
        ) : (
          <>
            <div className="w-16 h-16 border-4 border-sand-400 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
            <p className="text-sand-400">Completing authentication...</p>
          </>
        )}
      </div>
    </div>
  );
}